import { useMasterContext } from "provider/MasterProvider";
import { useSafariPackagesContext } from "provider/SharePackagesProvider";
import React from "react";
import { Row, Col } from "react-bootstrap";

const SelectedFilters = () => {
  const { filters, safariPackagesDispatch } = useSafariPackagesContext();
  const { parks, months, safariCategory, packageFeature, packageInclude, safariSortBy } = useMasterContext();

  const getTitleFromMaster = (list, id) =>
    list?.find((item) => Number(item.value) === Number(id))?.label || id;

  const masterMap = {
    stay_category_id: safariCategory,
    package_feature: packageFeature,
    package_include: packageInclude,
    park_id: parks,
    month_id: months,
    custom_sort_by: safariSortBy
  };

  const removeArrayItem = (key, itemToRemove) => {
    const newArray = filters[key].filter((item) => item !== itemToRemove);
    safariPackagesDispatch({
      type: "UPDATE_SAFARI_PACKAGES_FILTER",
      payload: { [key]: newArray.length > 0 ? newArray : 0 },
    });
  };

  const onRemove = (key) => {
    safariPackagesDispatch({
      type: "UPDATE_SAFARI_PACKAGES_FILTER",
      payload: { [key]: 0 },
    });
  };

  const onRemoveRange = (keys) => {
    const payload = {};
    keys.forEach((key) => (payload[key] = 0));
    safariPackagesDispatch({
      type: "UPDATE_SAFARI_PACKAGES_FILTER",
      payload,
    });
  };

  const hasTourDuration =
  (filters.no_of_night_min !== 0 &&
    filters.no_of_night_min !== null &&
    filters.no_of_night_min !== "") ||
  (filters.no_of_night_max !== 0 &&
    filters.no_of_night_max !== null &&
    filters.no_of_night_max !== "");


  const hasSafariRange =
    (filters.no_of_safari_min !== 0 &&
      filters.no_of_safari_min !== null &&
      filters.no_of_safari_min !== "") ||
    (filters.no_of_safari_max !== 0 &&
      filters.no_of_safari_max !== null &&
      filters.no_of_safari_max !== "");

  const hasPriceRange =
    (filters.estimated_price_filter_min !== 0 &&
      filters.estimated_price_filter_min !== null &&
      filters.estimated_price_filter_min !== "") ||
    (filters.estimated_price_filter_max !== 0 &&
      filters.estimated_price_filter_max !== null &&
      filters.estimated_price_filter_max !== "");
  return (
    <Row className="mb-3">
      <Col>
        <div className="d-flex flex-wrap align-items-center gap-2">
          {Object.entries(filters)
            .filter(
              ([key, value]) =>
                ![
                  "no_of_night_min",
                  "no_of_night_max",
                  "no_of_safari_min",
                  "no_of_safari_max",
                  "estimated_price_filter_min",
                  "estimated_price_filter_max",
                ].includes(key) &&
                value !== 0 &&
                value !== "" &&
                value !== null
            )
            .flatMap(([key, value]) => {
              const list = masterMap[key];

              // Handle arrays
              if (Array.isArray(value)) {
                return value.map((id) => {
                  const label = getTitleFromMaster(list, id);
                  return (
                    <span
                      key={`${key}-${id}`}
                      className="filter-sort px-4 py-2 d-flex align-items-center"
                      style={{ fontSize: "14px", cursor: "pointer" }}
                      onClick={() => removeArrayItem(key, id)}
                    >
                      {label}
                      <span className="ms-2">
                        <i className="fa-solid fa-x"></i>
                      </span>
                    </span>
                  );
                });
              }

              // Handle non-array
              const label = getTitleFromMaster(list || [], value);
              return (
                <span
                  key={key}
                  className="filter-sort px-4 py-2 d-flex align-items-center"
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  onClick={() => onRemove(key)}
                >
                  {label}
                  <span className="ms-2">
                    <i className="fa-solid fa-x"></i>
                  </span>
                </span>
              );
            })}
          {hasTourDuration && (
            <span
              className="filter-sort px-4 py-2 d-flex align-items-center"
              style={{ fontSize: "14px", cursor: "pointer" }}
              onClick={() =>
                onRemoveRange(["no_of_night_min", "no_of_night_max"])
              }
            >
              Nights:
              {filters.no_of_night_min ? ` ${filters.no_of_night_min}` : ""}
              {filters.no_of_night_min && filters.no_of_night_max ? " – " : ""}
              {filters.no_of_night_max ? ` ${filters.no_of_night_max}` : ""}
              <span className="ms-2">
                <i className="fa-solid fa-x"></i>
              </span>
            </span>
          )}

          {hasSafariRange && (
            <span
              className="filter-sort px-4 py-2 d-flex align-items-center"
              style={{ fontSize: "14px", cursor: "pointer" }}
              onClick={() => onRemoveRange(["no_of_safari_min", "no_of_safari_max"])}
            >
              Safari:
              {filters.no_of_safari_min ? ` ${filters.no_of_safari_min}` : ""}
              {filters.no_of_safari_min && filters.no_of_safari_max ? " – " : ""}
              {filters.no_of_safari_max ? ` ${filters.no_of_safari_max}` : ""}
              <span className="ms-2">
                <i className="fa-solid fa-x"></i>
              </span>
            </span>
          )}
          {hasPriceRange && (
            <span
              className="filter-sort px-4 py-2 d-flex align-items-center"
              style={{ fontSize: "14px", cursor: "pointer" }}
              onClick={() => onRemoveRange(["estimated_price_filter_min", "estimated_price_filter_max"])}
            >
              Cost:
              {filters.estimated_price_filter_min ? ` ${filters.estimated_price_filter_min}` : ""}
              {filters.estimated_price_filter_min && filters.estimated_price_filter_max ? " – " : ""}
              {filters.estimated_price_filter_max ? ` ${filters.estimated_price_filter_max}` : ""}
              <span className="ms-2">
                <i className="fa-solid fa-x"></i>
              </span>
            </span>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default SelectedFilters;
